module.exports = __webpack_public_path__ + "img/reacondicionamos.fbec16b3.jpg";